export default {
    baseStyle: {
        categoryTextStyle: {
            color: '#ffc94d',
            fontWeight: 'semibold',
            lineHeight: 'normal',
            marginBottom: '4'
        },
        productSugessionTextStyle: {
            fontSize: 'md',
            color: '#2f5161',
            lineHeight: 'normal',
            fontWeight: 'bold',
            paddingBottom: '3'
        }
    },
    parts: ['categoryTextStyle', 'productSugessionTextStyle']
}
